import { customElement } from 'solid-element';
import Icon from './Icon';
import { IconSize } from './icon-size';
import { noShadowDOM } from 'component-register';

export function defineSolidIcon(): void {
  customElement(
    'tc-icon',
    {
      icon: '',
      color: '',
      size: 'icon-medium' as IconSize,
      customClass: '',
      shadowDom: false,
    },
    (props, { element }) => {
      if (!props.shadowDom) noShadowDOM();

      function handleIconClick(): void {
        const evt = new CustomEvent('icon-click', {
          detail: {
            icon: props.icon,
            size: props.size,
          },
          bubbles: true,
          composed: true,
        });
        element.renderRoot.dispatchEvent(evt);
      }

      return (
        <div onClick={handleIconClick}>
          <Icon
            icon={props.icon}
            color={props.color}
            size={props.size}
            customClass={props.customClass}
          />
        </div>
      );
    }
  );
}
